<template>
  <div class="el-textarea">
    <QuestionRichBody
        :options="options"
        :value="element.labels[lang]"
        :lang="lang"
        :label="L.elTextareaLabel || 'Text'"
        @input="updateBody($event)" />
  </div>
</template>

<script>
import QuestionRichBody from '../QuestionRichBody.vue'

/**
 * 'textarea' element: a per-language rich-text body. Stores HTML in element.labels[lang].
 * Reuses the self-contained QuestionRichBody (owns its own tiptap instance per language).
 */
export default {
  name: 'ElTextarea',
  components: { QuestionRichBody },
  props: {
    options: { type: Object, required: true },
    element: { type: Object, required: true },
    lang: { type: String, default: 'de' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  },
  methods: {
    updateBody(val) { this.$set(this.element.labels, this.lang, val); }
  }
};
</script>

<style scoped>
.el-textarea { width: 100%; }
</style>
